import { BrandLogo } from '../brand/BrandLogo'
import { useAuth } from './useAuth'

export function LoadingScreen({ label = 'Checking your session…' }: { label?: string }) {
  return (
    <main className="auth-page auth-page-loading">
      <section className="portal-card auth-loading-card" aria-live="polite">
        <BrandLogo compact />
        <div className="auth-loading-body">
          <div className="auth-loading-spinner" aria-hidden="true" />
          <div className="auth-loading-text">
            <h2 className="auth-loading-title">{label}</h2>
            <p className="auth-loading-subtitle">Please wait</p>
          </div>
        </div>
      </section>
    </main>
  )
}

export function AccountPendingScreen() {
  const { logout, error } = useAuth()

  return (
    <main className="auth-page">
      <section className="portal-card">
        <p className="eyebrow">SGS Fee Portal</p>
        <h1>Account pending setup</h1>
        <p>Your account is authenticated, but an administrator has not assigned a portal role yet.</p>
        {error && <p className="error-message" role="alert">{error}</p>}
        <button className="button button-secondary" type="button" onClick={() => void logout()}>Log out</button>
      </section>
    </main>
  )
}

export function AccessDeniedScreen() {
  const { logout } = useAuth()

  return (
    <main className="auth-page">
      <section className="portal-card">
        <p className="eyebrow">SGS Fee Portal</p>
        <h1>Access not available</h1>
        <p>Your account does not have permission to open this area.</p>
        <button className="button button-secondary" type="button" onClick={() => void logout()}>Log out</button>
      </section>
    </main>
  )
}

export function AuthErrorScreen({ message }: { message: string }) {
  return (
    <main className="auth-page">
      <section className="portal-card">
        <p className="eyebrow">SGS Fee Portal</p>
        <h1>We could not verify your account</h1>
        <p className="error-message" role="alert">{message}</p>
        <p>Please try again later or contact the portal administrator.</p>
      </section>
    </main>
  )
}
